/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { findCases, sortCases, getCase, printCasesData, getCasesSelectItems } from '../../reducers/VfcReducer';
import DataTable from '../../components/DataTable';
import Report from './CaseReport';
import Paper from '@material-ui/core/Paper';
import FiltersPanel from '../../components/FiltersPanel';
import PrintData from '../../components/PrintData';
import searchFiltersConfig from '../../config/cases-search-filters.json';
import tableConfig from '../../config/cases-table.json';
import PrintIcon from '@material-ui/icons/Print';
import appConfig from '../../config/appConfig.json';

const useStyles = makeStyles(theme => ({
  page: {
    boxSizing: 'border-box'
  },
  searchBar: {
    padding: '30px 20px 30px',
    '& > h3': {
      color: '999',
      paddingLeft: 10,
    },
    '& > h4': {
      color: '#999',
      fontSize: 20
    },
  },
  tabs: {
    marginBottom: 30,
  },
  action: {
    textAlign: 'right',
    padding: '1em 0',
    '& button': {
      marginLeft: 10,
      '&:first-child': {
        marginLeft: 0,
      }
    }
  }
}));

function ReportList(props) {
  const classes = useStyles();
  const { cases, caseDetails, printData, casesSelectItems } = props.vfc;
  //console.log("ReportList", casesSelectItems);
  const webSocket = props.webSocket;  
  const { loading, loaded, rows, error } = cases;
  const [selected, setSelected] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (caseDetails.data && selected) setShowDetails(true);
  }, [caseDetails]);

  const getCasesSelectItems = () => {
    //console.log("p2:", Date.now());
    props.getCasesSelectItems();
  }
  useEffect(() => {  
    //console.log("p1:", Date.now(), webSocket);
    if(webSocket)
      getCasesSelectItems();
    
  }, [loaded, loading, webSocket]);

  const getData = options => {
    props.findCases(options);
  };

  const sort = name => {
    props.sortCases(name);
  };

  const selectRow = row => {
    setSelected(row);
  };

  const getReport = () => {
    props.getCase(selected.vfcMainId);//CaseNumber
  };

  const closeDetails = () => {
    setShowDetails(false);
  };

  const tableDblClick = () => {
    getReport();
  }

  const printList = () => {
    const msg = `The result array exceeds the maximum number of ${appConfig.maxPrintResults} rows.\n` +
    `Continue printing first ${appConfig.maxPrintResults} rows?`;
    if (cases.count > appConfig.maxPrintResults && !window.confirm(msg) ) return;
    props.printCasesData();
  }

  return (
    <div className={classes.page}>
      <Paper square className={classes.searchBar}>
        <h3>Archive Browser-Offense/Case Data</h3>
        {casesSelectItems && (<FiltersPanel getData={getData} config={searchFiltersConfig} data={cases} selectItems={casesSelectItems}/>)}
        {rows.length > 0 && (
          <Fragment>
            <h4>Search Results</h4>
            <div className={classes.action}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                onClick={printList}
                startIcon={<PrintIcon />}>
                Print List
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                onClick={getReport}
                startIcon={<AssignmentIcon />}
                disabled={!selected}>
                Show Details
              </Button>
            </div>
            <DataTable
              getData={getData}
              data={cases}
              config={tableConfig}
              sort={sort}
              selectRow={selectRow}
              dblClick={tableDblClick}
            />
          </Fragment>
        )}
        {loading && rows.length === 0 && <LoadingData />}
        {!loaded && !loading  && rows.length === 0 && <StartSearching />}
        {loaded && !loading  && rows.length === 0 && !error && <NoResults />}
        {loaded && !loading  && rows.length === 0 && error && <ErrorLoading />}
        {showDetails && <Report data={caseDetails.data} close={closeDetails} />}
      </Paper>
      {printData && <PrintData config={tableConfig}/>}
    </div>
  );
}

function NoResults() {
  return <h4>Sorry, no results match your search criteria.</h4>;
}

function LoadingData() {
  return <h4>Loading the data, plase wait...</h4>;
}

function StartSearching() {
  return <h4>Please define your search criteria.</h4>;
}

function ErrorLoading() {
  return <h4>There was an error while recieving the data.</h4>;
}

const mapStateToProps = state => {
  return {
    vfc: state.vfc,
    webSocket: state.websocket.websocket
  };
};

export default connect(mapStateToProps, {
  findCases, sortCases, getCase, printCasesData, getCasesSelectItems,
})(ReportList);
